"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getURL = exports.getBaseURL = void 0;
var _build_config = require("../config/build_config");
/**
 * @Author: Alexander Silva Barbosa
 * @Date:   2022-09-30 10:56:37
 * @Last Modified by:   Alexander Silva Barbosa
 * @Last Modified time: 2022-09-30 11:00:27
 */

const getBaseURL = () => {
  return (0, _build_config.getBuildConfiguration)().server_url_base;
};
exports.getBaseURL = getBaseURL;
const getURL = function (path) {
  let ipv4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let port = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let url = path;
  try {
    new URL(url);
  } catch (_) {
    if (ipv4 != null && port != null) {
      url = "http://" + ipv4 + ":" + port + "/" + url;
    } else if (url.startsWith('/')) {
      url = "".concat(getBaseURL()).concat(url);
    } else {
      url = "".concat(getBaseURL(), "/").concat(url);
    }
  }
  return url;
};
exports.getURL = getURL;